import {
  logout,
  login,
  getInfo,
  loginByCode,
  sendCode,
  register,
  wechatLogin,
  checkStatus,
  checkVerifyCode,
  getAreaCodeList,
  getUserPermissions,
} from "@saas/service-api/src/user-info/auth";
import {
  setToken,
  removeToken,
  setRefreshToken,
  removeRefreshToken,
  getOsInfo,
} from "@saas/service-api/src/plugins/auth";
import { Message } from "element-ui";
import { getMoguoCdnUrl } from "@saas/components/src/utils/assets";
const osInfo = getOsInfo();
const getDefaultState = () => {
  return {
    token: "",
    name: "",
    avatar: "",
    loginForm: {
      // 手机号
      mobile: "",
      // 密码
      password: "",
      code: "",
      sceneStr: "",
      // 手机区号
      region_num: "",
    },
    userInfo: {},
    // 30天自动登录
    autoLogin: false,
    expires: 30,
    // 角色包含以及大于当前用户的用户列表
    userList: [],
    // 是否展示无权限弹窗
    noPermissionVisible: false,
    // 国家区号
    areaCodeList: [],
    // 权限
    permissions: [],
  };
};

const state = getDefaultState();

const mutations = {
  RESET_STATE: (state) => {
    Object.assign(state, getDefaultState());
  },
  SET_TOKEN: (state, token) => {
    state.token = token;
  },
  SET_NAME: (state, name) => {
    state.name = name;
  },
  SET_AVATAR: (state, avatar) => {
    state.avatar =
      avatar || getMoguoCdnUrl("/cdn/static/images/default_avatar.png");
  },
  SET_LOGIN_FORM: (state, loginForm) => {
    state.loginForm = { ...state.loginForm, ...loginForm };
  },
  SET_USER_INFO: (state, userInfo) => {
    state.userInfo = userInfo;
  },
  SET_AUTO_LOGIN: (state, autoLogin) => {
    state.autoLogin = autoLogin;
  },
  SET_USER_LIST: (state, userlist) => {
    state.userList = userlist;
  },
  SET_NO_PERMISSION_VISIBLE: (state, val) => {
    state.noPermissionVisible = val;
  },
  SET_AREA_CODE_LIST: (state, areaCodeList) => {
    state.areaCodeList = areaCodeList;
  },
  SET_PERMISSIONS: (state, permissions) => {
    state.permissions = permissions;
  },
};

const actions = {
  // 账号密码登录
  login({ commit, state }, payload) {
    const deviceId = localStorage.getItem("deviceId");
    const osParams = window.isElectron
      ? {
        device_unique_id: deviceId,
        device_name: osInfo.hostname,
        device_type: osInfo.platform === "win32" ? 1 : 2,
      }
      : {};
    return new Promise((resolve, reject) => {
      login({
        ...payload,
        remember_me: state.autoLogin,
        ...osParams,
      })
        .then(({ code, data, message }) => {
          if (code === 1) {
            setToken(data.access_token, state.autoLogin ? state.expires : 1);
            setRefreshToken(data.refresh_token);
          }
          resolve({ code, data, message });
        })
        .catch((error) => {
          reject(error);
        });
    });
  },
  // 退出
  logout({ commit, state, dispatch }) {
    return new Promise((resolve, reject) => {
      logout()
        .then(({ code, data, message }) => {
          if (code === 1) {
            dispatch("resetToken");
          } else {
            Message({
              message: message,
              type: "error",
            });
          }
          resolve({ code, data, message });
        })
        .catch((error) => {
          reject(error);
        });
    });
  },
  // 验证码登录
  loginByCode({ commit, state }, payload) {
    const deviceId = localStorage.getItem("deviceId");
    const osParams = window.isElectron
      ? {
        device_unique_id: deviceId,
        device_name: osInfo.hostname,
        device_type: osInfo.platform === "win32" ? 1 : 2,
      }
      : {};
    return new Promise((resolve, reject) => {
      loginByCode({
        ...payload,
        remember_me: state.autoLogin,
        auto_register: true,
        ...osParams,
      })
        .then(({ code, data, message }) => {
          if (code !== 1 && code !== 20000) {
            Message({
              message,
              type: "error",
              duration: 3 * 1000,
            });
          } else {
            //   commit('SET_TOKEN', data.accessToken)
            setToken(data.access_token, state.autoLogin ? state.expires : 1);
            setRefreshToken(data.refresh_token);
            localStorage.setItem("regionNum", state.loginForm.region_num);
          }
          resolve({ code, data, message });
        })
        .catch((error) => {
          reject(error);
        });
    });
  },
  // 发送验证码
  sendCode({ commit }, payload) {
    return new Promise((resolve, reject) => {
      sendCode(payload)
        .then(({ code, data, message }) => {
          if (code === 1) {
            resolve({ code, data, message });
          } else {
            Message({
              message,
              type: "error",
              duration: 3 * 1000,
            });
            resolve({ code, message });
          }
        })
        .catch((error) => {
          reject(error);
        });
    });
  },

  // get user info
  getInfo({ commit, state, dispatch }, type) {
    return new Promise((resolve, reject) => {
      getInfo({ is_teacher: true })
        .then(async (response) => {
          const { code, data } = response;
          if (code === 1) {
            commit("SET_USER_INFO", data);
            commit("SET_AVATAR", data.avatar);
            dispatch("getUserPermissions");
            if (type === "login") {
              const event = new CustomEvent("login-success", {
                detail: {
                  user_id: data.user_id,
                },
              });
              window.dispatchEvent(event);
            }
            resolve(response);
          } else {
            commit("SET_USER_INFO", {});
            commit("SET_AVATAR", "");
            commit("SET_USER_LIST", []);
            reject(response);
          }
        })
        .catch((error) => {
          reject(error);
        });
    });
  },

  // 重置用户信息
  resetToken({ commit }) {
    return new Promise((resolve) => {
      removeToken(); // must remove  token  first
      removeRefreshToken();
      commit("RESET_STATE");
      resolve();
    });
  },
  changeNoPermissionVisible({ commit }, payload) {
    return new Promise((resolve) => {
      commit("SET_NO_PERMISSION_VISIBLE", payload);
      resolve();
    });
  },
  register({ commit, state }, payload) {
    const deviceId = localStorage.getItem("deviceId");
    const osParams = window.isElectron
      ? {
        device_unique_id: deviceId,
        device_name: osInfo.hostname,
        device_type: osInfo.platform === "win32" ? 1 : 2,
      }
      : {};
    return new Promise((resolve, reject) => {
      register({
        ...payload,
        remember_me: state.autoLogin,
        ...osParams,
      })
        .then(({ code, data, message }) => {
          if (code === 1) {
            setToken(data.access_token, state.autoLogin ? state.expires : 1);
            setRefreshToken(data.refresh_token);
            localStorage.setItem("regionNum", state.loginForm.region_num);
            resolve({ code, data, message });
          } else {
            Message({
              message,
              type: "error",
              duration: 3 * 1000,
            });
            resolve({ code, message });
          }
        })
        .catch((error) => {
          reject(error);
        });
    });
  },
  wechatLogin({ commit }, payload) {
    return new Promise((resolve, reject) => {
      wechatLogin(payload)
        .then(({ code, data, message }) => {
          if (code === 1) {
            resolve({ code, data, message });
          } else {
            Message({
              message,
              type: "error",
              duration: 3 * 1000,
            });
            resolve({ code, message });
          }
        })
        .catch((error) => {
          reject(error);
        });
    });
  },
  // 检查微信扫码状态
  checkStatus({ commit, state }, payload) {
    const deviceId = localStorage.getItem("deviceId");
    const osParams = window.isElectron
      ? {
        device_unique_id: deviceId,
        device_name: osInfo.hostname,
        device_type: osInfo.platform === "win32" ? 1 : 2,
      }
      : {};
    return new Promise((resolve, reject) => {
      checkStatus({
        ...payload,
        remember_me: state.autoLogin,
        ...osParams,
      })
        .then(({ code, data, message }) => {
          if (code === 1) {
            setToken(data.access_token, state.autoLogin ? state.expires : 1);
            setRefreshToken(data.refresh_token);
            resolve({ code, data, message });
          } else {
            resolve({ code, message });
          }
        })
        .catch((error) => {
          reject(error);
        });
    });
  },
  // 检查微信扫码状态
  checkVerifyCode({ commit, state }, payload) {
    const deviceId = localStorage.getItem("deviceId");
    const osParams = window.isElectron
      ? {
        device_unique_id: deviceId,
        device_name: osInfo.hostname,
        device_type: osInfo.platform === "win32" ? 1 : 2,
      }
      : {};
    return new Promise((resolve, reject) => {
      checkVerifyCode({
        ...payload,
        remember_me: state.autoLogin,
        ...osParams,
      })
        .then(({ code, data, message }) => {
          if (code === 1) {
            if (data.access_token && data.refresh_token) {
              setToken(data.access_token, state.autoLogin ? state.expires : 1);
              setRefreshToken(data.refresh_token);
              localStorage.setItem("regionNum", state.loginForm.region_num);
            }
            resolve({ code, data, message });
          } else {
            resolve({ code, message });
          }
        })
        .catch((error) => {
          reject(error);
        });
    });
  },
  // 获取国家和地区区号
  getCountryCode({ commit }) {
    return new Promise((resolve, reject) => {
      getAreaCodeList()
        .then(({ code, data, message }) => {
          console.log(data);
          if (code === 1) {
            commit("SET_AREA_CODE_LIST", data);
            resolve({ code, data, message });
          } else {
            resolve({ code, message });
          }
        })
        .catch((error) => {
          reject(error);
        });
    });
  },
  loginSuccess({ state, commit, dispatch }, payload) {
    setToken(payload.access_token);
    setRefreshToken(payload.refresh_token);
  },
  getUserPermissions({ commit }) {
    return new Promise((resolve, reject) => {
      getUserPermissions()
        .then(({ code, data, message }) => {
          if (code === 1) {
            commit("SET_PERMISSIONS", data || []);
            resolve({ code, data, message });
          } else {
            reject(message);
          }
        })
        .catch((error) => {
          reject(error);
        });
    });
  },
};

export default {
  namespaced: true,
  state,
  mutations,
  actions,
};
